import { Card } from "@/components/ui";
import { cn } from "@/lib/utils";
import React from "react";

export function FormCard({ children, className }: { children: React.ReactNode; className?: string }) {
  return (
    <Card className={cn("flex flex-col bg-white shadow-sm border-slate-200 rounded-xl overflow-hidden", className)}>
      {children}
    </Card>
  );
}

FormCard.Header = function FormCardHeader({ title, description }: { title: string; description?: string }) {
  return (
    <Card.Header className="pb-4">
      <Card.Title className="text-lg font-semibold tracking-tight text-slate-900">{title}</Card.Title>
      {description && <Card.Description className="text-sm text-slate-500">{description}</Card.Description>}
    </Card.Header>
  );
};

FormCard.Content = function FormCardContent({
  children,
  className,
}: {
  children: React.ReactNode;
  className?: string;
}) {
  return <Card.Content className={cn("flex flex-col gap-4 grow", className)}>{children}</Card.Content>;
};

FormCard.Actions = function FormCardActions({
  children,
  className,
}: {
  children: React.ReactNode;
  className?: string;
}) {
  return (
    <Card.Footer
      className={cn("flex justify-end gap-3 mt-auto pt-4 pb-4 border-t border-slate-100 bg-slate-50/50", className)}
    >
      {children}
    </Card.Footer>
  );
};
